import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";
import profileFields from "./profileFields";

export default {
    entityName: "drivers",
    pageTitle: "Drivers",
    columns,
    searchFields,
    searchPlaceholder: "e.g. name:joe or email:joe@doe.com",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
    previewOptions: {
        fetchEntity: true,
    },
    profileFields,
};
